import { Avatar, Box, Stack, Typography } from "@mui/material";

function BlogAndNewsCard() {
  return (
    <Stack direction="column" sx={{ alignItems: "start", width: "350px" }}>
      {" "}
      <Box
        component="img"
        src="/images/marketingGenius.jpg"
        sx={{
          // width: "450px",
          // height: "280px",
          width: "350px",
          height: "250px",
          objectFit: "cover",
          borderRadius: "30px",
          display: "block",
          border: "none",
          bgcolor: "#D9D9D9",
        }}
      ></Box>
      <Typography
        variant="body2"
        sx={{
          fontSize: "14px",
          lineHeight: "22px",
          color: "#000000",
          bgcolor: "#FDDF59",
          borderRadius: "30px",
          textAlign: "center",
          px: "20px",
          py: "4px",
          my: "30px",
          fontWeight: "500",
        }}
      >
        Tips
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: "30px",
          lineHeight: "100%",
          color: "#0E0B33",
          fontFamily: "Inter",
          fontWeight: "700",
        }}
      >
        5 Tips for Crafting a Winning Resume
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: "14px",
          lineHeight: "22px",
          color: "#0E0B33",
          fontFamily: "Inter",
          fontWeight: "400",
          py: "6px",
        }}
      >
        Our advice on how to create the winning resume in your current job
        application process to eliminate your competitions.
      </Typography>
      <Stack
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          py: "20px",
        }}
      >
        <Avatar
          sx={{
            bgcolor: "#D9D9D9",
            width: "60px",
            height: "60px",
            color: "#D9D9D9",
          }}
        ></Avatar>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontSize: "16px",
              lineHeight: "22px",
              color: "#0E0B33",
              fontFamily: "Inter",
              fontWeight: "700",
            }}
          >
            Sarah Jones
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              lineHeight: "22px",
              color: "#878599",
              fontFamily: "Inter",
              fontWeight: "400",
            }}
          >
            Feb 15, 2023
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
}

export default BlogAndNewsCard;
